import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PolicySelectorField } from "../PolicySelector";
export const AnalyticsPermission = () => {
    const intl = useIntl();
    const policyOptions = [
        {
            value: [],
            label: intl.formatMessage(messages.analyticsPermissionOptionView),
        },
        {
            value: ["analytics_read" /* PolicyActions.ANALYTICS_READ */],
            label: intl.formatMessage(messages.analyticsPermissionOptionDeny),
        },
    ];
    return (React.createElement(PolicySelectorField, { label: intl.formatMessage(messages.analyticsPermissionLabel), policyOptions: policyOptions, id: "deny.analytics" }));
};
export default AnalyticsPermission;
